export enum AppRoutes {
  EMPTY = '',
  AUTH = 'auth',
  LOGIN = 'login',
  WELCOME = 'welcome',
  PROJECT = 'project',
  RESPONDENT = 'respondent',
  ADMIN = 'admin',
}
